import { MutableRefObject } from 'react';
import { FieldPath, FieldValues, UseControllerProps, useController } from 'react-hook-form';
import * as SingleSelect from '@givebutter/primitives/single-select';
import { get } from 'lodash';

interface UseFormSingleSelectProps<T extends FieldValues, K extends FieldPath<T>>
    extends UseControllerProps<T, K>,
        Omit<SingleSelect.SingleSelectRootProps, 'defaultValue' | 'name'> {}

const UseFormSingleSelect = <T extends FieldValues, K extends FieldPath<T>>(
    props: UseFormSingleSelectProps<T, K>,
) => {
    const {
        control,
        name,
        defaultValue,
        rules,
        onValueChange: onChangeConsumer,
        ...restProps
    } = props;
    const {
        field: { onChange: onChangeInternal, value, ref, ...restFormProps },
        formState: { errors },
    } = useController({
        name,
        control,
        defaultValue,
        rules,
    });

    const onChange = (value: string) => {
        onChangeInternal(value);
        onChangeConsumer?.(value);
    };

    return (
        <SingleSelect.Root
            {...restProps}
            {...restFormProps}
            triggerRef={ref as unknown as MutableRefObject<HTMLButtonElement>}
            error={Boolean(get(errors, name))}
            value={value}
            onValueChange={onChange}
        />
    );
};

export { UseFormSingleSelect };
export type { UseFormSingleSelectProps };
